// Bob9ine — full discography + content for the artist page.
// Edit this file to keep music, merch, and socials up to date.

export const ARTIST = {
  name: "BOB9INE",
  tagline: "Born From Sound",
  bio: "Independent recording artist. Stack of EPs, albums and singles across all major platforms.",
};

// Streaming platform URLs (artist-level — applied to every release).
const PLATFORM = {
  spotify:
    "https://open.spotify.com/artist/3EIC9AagpOAjWuNsd0QLUu?si=OZJtaj24RASoIVakyo-sVw",
  youtube:
    "https://youtube.com/channel/UCn2TX6watMQwrOD9LaJKXtA?si=--AEcSZESMjwvKxd",
  soundcloud: "https://soundcloud.com/bob9ine",
};

// Newest → oldest. `apple` links go directly to the specific release.
// Add `popular: true` and `lyrics: "..."` (or `lyrics` as an array of stanzas)
// to a release to include it in the Song of the Day rotation.
export const RELEASES = [
  {
    id: "lover-boy-2",
    title: "Lover Boy 2",
    type: "Album",
    year: "2026",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/59/aa/fa/59aafa19-34a3-4093-8800-9817605c8667/888193537202-copy-e49159b9.png/600x600bb.jpg",
    apple: "https://music.apple.com/us/album/lover-boy-2/6810995200",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/c7/1e/84/c71e8429-b03f-d7ff-7748-38135a1b1708/mzaf_9741871904200010838.plus.aac.p.m4a",
  },
  {
    id: "unsettling-environments",
    title: "Unsettling Environments",
    type: "Single",
    year: "2026",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/f8/e9/65/f8e965d1-70f3-ca03-2396-a17856acaf7f/881392665028-copy-ea5e98f5.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/unsettling-environments-single/6793341165",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/40/f5/ed/40f5edc9-ec25-1bc9-df5a-ea22d0adf000/mzaf_13709139726869162447.plus.aac.p.m4a",
  },
  {
    id: "still-my-fault",
    title: "Still My Fault?",
    type: "Album",
    year: "2026",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/13/5f/83/135f83dc-618f-79fc-d3dc-4683ab2bdbe2/827425366692.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/still-my-fault/6767619519",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/61/c0/92/61c092e1-9c36-a602-6428-80582456efd6/mzaf_13026483687223418307.plus.aac.p.m4a",
  },
  {
    id: "a-lot",
    title: "A lot",
    type: "Single",
    year: "2026",
    popular: true,
    lyrics: `Yeah
What, okay
Yeah
Flyest nigga in the game, yeah this fit cost a lot
I get the commas and the cheese, if I'm working or not
Yeah these hoes can't get no money, most these hoes be some thots
Hellcat power, 707, and all these horses they trot

Like how much? A lot
How much? A lot
How much? A lot
How much? A lot
How much? A lot
How much? A lot
How much? A lot

God these bitches are funny, and these niggas are jokes
Could never be a good person is your reason to cope
Bitch
Nigga's praying for their favorite rapper, nigga pray for some hope
Never see me sink to y'all level no nigga I ain't no boat (Titanic)
Have you seen 50k? Well nigga it fits in this coat
VVS diamonds on my neck, hope I don't choke
Cause this shit gripping like I grip my gun, yeah nigga I tote
7.62's, like yeah nigga that's it cause you gunna float

Like how much? A lot
How much? A lot
How much? A lot
How?
How much? A lot
How much? A lot
How much? A lot
How much? A lot`,
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/5c/fb/c9/5cfbc973-3d6e-0b2e-9c84-86387313564f/822299791168-copy-705244c5.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/a-lot-single/1891437463",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/d8/5f/e8/d85fe896-e899-6510-f951-10776392d829/mzaf_7799714778911893954.plus.aac.p.m4a",
  },
  {
    id: "onna",
    title: "onna",
    type: "Single",
    year: "2026",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/ba/43/2e/ba432ebc-3e21-d9f9-b06f-cc0960c7cc69/822299805544-copy-fcb16d45.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/onna-single/1891545745",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/40/ad/93/40ad9399-1224-81da-b551-43e610c1fff2/mzaf_6615777873906834181.plus.aac.p.m4a",
  },
  {
    id: "throwaways",
    title: "The Throwaways",
    type: "EP",
    year: "2026",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/b0/94/12/b094126a-3e1c-f466-800a-f545c031cbca/822299237734-copy-b22bf186.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/the-throwaways-ep/1882787626",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/a9/85/d9/a985d9a7-9371-976a-128d-708fbc99edb3/mzaf_15751302057531459914.plus.aac.p.m4a",
  },
  {
    id: "out-of-orbit",
    title: "Out of Orbit",
    type: "EP",
    year: "2026",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/42/3c/7a/423c7a57-a20d-b910-953f-87aaa0234ef6/057914727943.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/out-of-orbit-ep/1872483477",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/dc/9c/d5/dc9cd5ff-2595-ede7-988d-d95c04208e99/mzaf_3456205537334247933.plus.aac.p.m4a",
  },
  {
    id: "still-here-somehow",
    title: "Still Here, Somehow",
    type: "EP",
    year: "2026",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/81/35/44/81354465-3d73-09db-ed85-76c80caaaed1/199976142637-copy-045efd83.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/still-here-somehow-ep/1865520924",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/7f/05/f1/7f05f1cf-47f2-a246-8a1c-0553663fe595/mzaf_3881731680861709119.plus.aac.p.m4a",
  },
  {
    id: "reset-the-sun",
    title: "reset the sun",
    type: "EP",
    year: "2025",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/01/29/ca/0129ca27-c9d5-3d73-6999-0a75f5ceeb3a/199633844928-copy-05a47671.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/reset-the-sun-ep/1843947065",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/4f/aa/4d/4faa4d77-6e38-7468-0d14-fc3bd00e05d0/mzaf_1967500256556140055.plus.aac.p.m4a",
  },
  {
    id: "still-blaming-bobby",
    title: "Still Blaming Bobby",
    type: "EP",
    year: "2025",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/20/ed/d5/20edd5ad-1749-3dfc-382a-27974b344b2d/199479980866-copy-5f7bce0c.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/still-blaming-bobby-ep/1832554456",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/a2/d8/80/a2d88051-a908-440c-c9bf-0fcb19e52b80/mzaf_8036328088374915127.plus.aac.p.m4a",
  },
  {
    id: "troubled-man",
    title: "Troubled Man",
    type: "Single",
    year: "2025",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/83/3d/de/833dde8a-ba55-9ba1-4f22-9391f665906c/199479185025-copy-f4b3463b.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/troubled-man-single/1823022688",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/a2/e1/17/a2e11788-a02e-b956-7323-3e194749d1af/mzaf_6159443457281506407.plus.aac.p.m4a",
  },
  {
    id: "tearful-ballads",
    title: "Tearful Ballads",
    type: "Album",
    year: "2025",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music221/v4/98/00/e3/9800e350-f72b-4732-2d91-36dc36ece71e/199355526744-copy-365a8c06.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/tearful-ballads/1815309650",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/82/af/c1/82afc13c-6883-be29-9b95-c1df241124a3/mzaf_9083147694080341274.plus.aac.p.m4a",
  },
  {
    id: "was-a-loverboy",
    title: "Was A Loverboy",
    type: "EP",
    year: "2025",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/4b/52/bf/4b52bf33-f468-77c8-f674-3fddc79555a4/199231736410-copy-2146b87c.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/was-a-loverboy-ep/1805902736",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/0a/cc/a8/0acca8d2-7d49-874d-10ce-93e8a1ada259/mzaf_17228028749150380535.plus.aac.p.m4a",
  },
  {
    id: "unreal",
    title: "Unreal",
    type: "Single",
    year: "2025",
    popular: true,
    lyrics: "",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/d7/35/23/d7352368-fa90-206c-2d5c-b309d28ecc36/artwork.jpg/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/unreal-single/1788575553",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/eb/17/69/eb17691b-1c5a-dc78-4a29-2469b44f8775/mzaf_12788845544718078975.plus.aac.p.m4a",
  },
  {
    id: "in-loving-memory",
    title: "In Loving Memory",
    type: "Album",
    year: "2024",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/d3/c2/d9/d3c2d9e0-bb42-0934-7631-ac0a3c7270b6/198748065433-copy-eaf1d586.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/in-loving-memory/1764791769",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview221/v4/52/8a/98/528a98bb-7c68-b32d-db51-ae8ad1e1c0b5/mzaf_2382846702562276412.plus.aac.p.m4a",
  },
  {
    id: "demons-and-angels",
    title: "Demons And Angels",
    type: "Album",
    year: "2023",
    cover:
      "https://is1-ssl.mzstatic.com/image/thumb/Music211/v4/44/81/28/448128aa-a8d4-5b66-7752-99209e5f8907/197580089775_dBCnkeH-copy-38361f57.png/600x600bb.jpg",
    apple:
      "https://music.apple.com/us/album/demons-and-angels/1680574941",
    preview:
      "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview211/v4/1f/a4/c3/1fa4c3c7-0278-474e-f004-93cf35adfca5/mzaf_14712165599751079894.plus.aac.p.m4a",
  },
].map((r) => ({
  ...r,
  links: {
    spotify: PLATFORM.spotify,
    apple: r.apple,
    youtube: PLATFORM.youtube,
    soundcloud: PLATFORM.soundcloud,
  },
}));

export const MERCH_COMING_SOON = true;

export const SOCIALS = [
  {
    id: "instagram",
    name: "Instagram",
    handle: "@bob9inee",
    url: "https://instagram.com/bob9inee",
  },
  {
    id: "tiktok",
    name: "TikTok",
    handle: "@bjwheni",
    url: "https://tiktok.com/@bjwheni",
  },
  {
    id: "twitter",
    name: "Twitter / X",
    handle: "@bjwheni",
    url: "https://twitter.com/bjwheni",
  },
];
